// File: src/components/ContactFeedback.jsx
import React, { useState } from "react";

const ContactFeedback = () => {
  const [contactData, setContactData] = useState({ name: "", email: "", message: "" });
  const [feedback, setFeedback] = useState({ rating: 5, comment: "" });

  const handleContactSubmit = (e) => {
    e.preventDefault();
    alert(`Thanks ${contactData.name}! We will contact you soon.`);
    setContactData({ name: "", email: "", message: "" });
  };

  const handleFeedbackSubmit = (e) => {
    e.preventDefault();
    alert(`Thanks for ${feedback.rating}-star feedback!`);
    setFeedback({ rating: 5, comment: "" });
  };

  return (
    <section className="contact-feedback-area" id="feedback">
      <div className="grid-container">
        <div className="form-card">
          <div className="card-header">
            <h3>Contact Us</h3>
            <div style={{ marginTop: "10px", borderTop: "1px solid #eee", paddingTop: "10px" }}>
              <p>📧 Email: info@ramcharanprojects.com</p>
              <p>📞 Call: +91</p>
            </div>
          </div>
          <form onSubmit={handleContactSubmit}>
            <input type="text" placeholder="Name" value={contactData.name} onChange={(e) => setContactData({ ...contactData, name: e.target.value })} required />
            <input type="email" placeholder="Email" value={contactData.email} onChange={(e) => setContactData({ ...contactData, email: e.target.value })} required />
            <textarea placeholder="Message" value={contactData.message} onChange={(e) => setContactData({ ...contactData, message: e.target.value })} required />
            <button className="btn-submit">Send Message</button>
          </form>
        </div>

        <div className="form-card">
          <div className="card-header">
            <h3>Client Feedback</h3>
          </div>
          <form onSubmit={handleFeedbackSubmit}>
            <div className="stars">
              {[1, 2, 3, 4, 5].map((s) => (
                <span key={s} className={`star ${feedback.rating >= s ? "active" : ""}`} onClick={() => setFeedback({ ...feedback, rating: s })}>★</span>
              ))}
            </div>
            <textarea placeholder="Feedback" value={feedback.comment} onChange={(e) => setFeedback({ ...feedback, comment: e.target.value })} required />
            <button className="btn-submit secondary">Submit Feedback</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactFeedback;